import {makeAdUrl} from '@frontend/helpers'
import type {AdPreviewDataForList} from '@frontend/modules/public/ads/AdsModuleTypes'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {HtmlContent} from 'swayok-react-mdb-ui-kit/components/Typography/HtmlContent'
import {useEventCallback} from 'swayok-react-mdb-ui-kit/helpers/useEventCallback'
import {AnalyticsEventReporter} from '../../../../../helpers/AnalyticsEventReporter'

interface AdsListItemInfoProps {
    ad: AdPreviewDataForList
}

// Содержимое карточки предпросмотра объявления в списке.
export function AdsListItemInfo(props: AdsListItemInfoProps) {

    const {
        ad,
    } = props

    // Обработчик нажатия на карточку объявления.
    const onClick = useEventCallback(() => {
        AnalyticsEventReporter.clickOnAdFromList(ad)
    })

    return (
        <div className="offered-item-card-info flex-xxl-1">
            <Link
                className={clsx(
                    'offered-item-card-title fw-500',
                    'd-none',
                    'd-sm-inline',
                    'd-md-none',
                    'd-lg-inline'
                )}
                target="_blank"
                to={makeAdUrl(ad.id)}
                rel="noreferrer"
                onClick={onClick}
            >
                {ad.title}
            </Link>
            <div
                className={clsx(
                    'text-center',
                    'mt-sm-2 text-sm-start',
                    'mt-md-0 text-md-center ',
                    'mt-lg-2 text-lg-start'
                )}
            >
                <div
                    className={clsx(
                        'offered-item-price-wrapper',
                        'd-inline-flex flex-row align-items-stretch justify-content-center'
                    )}
                >
                    <div
                        className={clsx(
                            'offered-item-price ps-3 py-1 bg-light-gray z-index-2 flex-1 flex-center',
                            ad.discountPercent ? 'pe-3' : 'pe-3'
                        )}
                    >
                        <div className="d-inline-block">
                            <div className="fw-500 text-nowrap">
                                {ad.price}
                            </div>
                            {ad.previousPrice && ad.discountPercent && (
                                <div className="offered-item-old-price mt-n1 fs-8 text-muted">
                                    {ad.previousPrice}
                                </div>
                            )}
                        </div>
                    </div>
                    {ad.discountPercent && (
                        <div className="offered-item-price-discount bg-orange z-index-1 ms-n5 ps-6 pe-3 flex-center fw-500">
                            <span>
                                &minus;{ad.discountPercent}%
                            </span>
                        </div>
                    )}
                </div>
            </div>
            <div className="mt-2 d-flex flex-column align-items-stretch gap-1">
                {ad.location && (
                    <div className="fs-7">
                        {ad.location}
                    </div>
                )}
                {ad.properties && ad.properties.length > 0 && (
                    <div className="offered-item-properties fs-7 text-muted">
                        {ad.properties.map((value, index) => (
                            <span key={index}>{value}</span>
                        ))}
                    </div>
                )}
                <HtmlContent
                    block
                    html={ad.description}
                    className="offered-item-description text-muted fs-7"
                />
            </div>
        </div>
    )
}
